import './styles/iconBtn.css';
import * as LucideIcons from 'lucide-react';
import classNames from 'classnames';
import { playSound } from '../utils/soundEffectHelper';

interface IconBtnProps {
  icon: keyof typeof LucideIcons;
  fill?: boolean;
  largeStrokeSize?: boolean;
  mediumStrokeSize?: boolean;
  xl?: boolean;
  noBackground?: boolean;
  secondary?: boolean;
  onClick: () => void;
}

function IconBtn(props: IconBtnProps) {
  const { icon, onClick, fill, largeStrokeSize, mediumStrokeSize, xl, noBackground, secondary } =
    props;

  const iconBtnClass = classNames('icon-btn', {
    'icon-btn-xl': xl,
    'icon-btn-no-bg': noBackground,
    'icon-btn-secondary': secondary,
  });
  const iconSvgClass = classNames('icon-svg', {
    'icon-fill': fill,
    'icon-stroke-large': largeStrokeSize,
    'icon-stroke-medium': mediumStrokeSize,
    'icon-xl': xl,
  });
  const IconComponent = LucideIcons[icon] as React.ElementType;

  return (
    <button
      className={iconBtnClass}
      onClick={() => {
        onClick();
        playSound('iconBtnClick');
      }}
    >
      <IconComponent className={iconSvgClass} />
    </button>
  );
}

export default IconBtn;
